/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const MyPerks = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="#3D3D36"
        d="M17.7,6.7h-2c0.4-0.4,0.7-1,0.8-1.4c0.3-0.9,0.1-1.7-0.4-2.2c-0.3-0.3-0.8-0.5-1.3-0.5
c-0.8,0-1.6,0.4-2.3,1.2c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1-0.2-0.3-0.4-0.5-0.6C10.8,2.9,10,2.5,9.2,2.5c-0.5,0-1,0.2-1.3,0.5
C7.4,3.6,7.2,4.4,7.5,5.3c0.2,0.5,0.5,1,0.8,1.4H6.3C5.6,6.7,5,7.3,5,8v12c0,0.7,0.6,1.3,1.3,1.3h11.4c0.7,0,1.3-0.6,1.3-1.3V8
C19,7.3,18.4,6.7,17.7,6.7z M13.4,4.6c0.5-0.5,1-0.8,1.4-0.8c0.2,0,0.3,0,0.4,0.1c0.3,0.3,0.1,1.2-0.6,1.9c-0.5,0.5-1,0.8-1.4,0.8
c-0.2,0-0.3,0-0.4-0.1C12.5,6.2,12.7,5.3,13.4,4.6z M8.8,4C8.9,3.9,9,3.8,9.2,3.8c0.4,0,0.9,0.3,1.4,0.8c0.7,0.7,0.9,1.6,0.6,1.9
c-0.1,0.1-0.2,0.1-0.4,0.1c-0.4,0-0.9-0.3-1.4-0.8C8.7,5.2,8.5,4.4,8.8,4z M17.7,20H6.3V8h11.4V20z M8.4,14.7h2.9v3.1
c0,0.4,0.3,0.7,0.6,0.7s0.6-0.3,0.6-0.7v-3.1h2.9c0.4,0,0.6-0.3,0.6-0.7s-0.3-0.7-0.6-0.7h-2.9v-3.1c0-0.4-0.3-0.7-0.6-0.7
s-0.6,0.3-0.6,0.7v3.1H8.4c-0.4,0-0.6,0.3-0.6,0.7S8.1,14.7,8.4,14.7z"
      />
    </BaseSvgIcon>
  )
}

export default MyPerks
